import { Icons } from "atoms/constants/icons";
import ToggleButton from "atoms/forms/toggle-button";
import Icon from "atoms/icons/icon";
import PageBlockToolbarWrapper from "molecules/page-block-content/page-block-toolbar-wrapper";
import PageBlockContextMenu from "organisms/page-blocks/page-block-list/page-block-context-menu";
import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-page-block-checklist-menu";

interface PageBlockChecklistMenuProps {
    isNumbered: boolean;
    showStatus: boolean;
    onToggleNumbering: (checked: boolean) => void;
    onToggleStatus: (checked: boolean) => void;
    onDone?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onDelete: () => Promise<void>;
    onMoveUp: () => Promise<void>;
    onMoveDown: () => Promise<void>;
}

const PageBlockChecklistMenu: React.FC<PageBlockChecklistMenuProps> = ({
    isNumbered,
    showStatus,
    onToggleNumbering,
    onToggleStatus,
    onDone,
    onDelete,
    onMoveDown,
    onMoveUp,
}) => {
    const showAIIcons = false;
    return (
        <PageBlockToolbarWrapper onDone={onDone}>
            <div className={CSS_CLASS_NAME}>
                {showAIIcons && (
                    <>
                        <div>
                            <Icon type={Icons.Vector} />
                        </div>
                        <div className={`${CSS_CLASS_NAME}__separator`} />
                    </>
                )}
                <div
                    className={`${CSS_CLASS_NAME}__toggle ${isNumbered ? "-on" : ""}`}>
                    <label className={`${CSS_CLASS_NAME}__label`}>
                        {t("checklist-numbering")}
                    </label>
                    <ToggleButton
                        checked={isNumbered}
                        label={t("checklist-numbering")}
                        onChange={() => onToggleNumbering(isNumbered)}
                        tabIndex={-1}
                    />
                </div>
                <div
                    className={`${CSS_CLASS_NAME}__toggle ${showStatus ? "-on" : ""}`}>
                    <label className={`${CSS_CLASS_NAME}__label`}>
                        {t("checklist-status")}
                    </label>
                    <ToggleButton
                        checked={showStatus}
                        label={t("checklist-status")}
                        onChange={() => onToggleStatus(showStatus)}
                        tabIndex={-1}
                    />
                </div>
                <PageBlockContextMenu
                    inline
                    mobileOnly
                    onDelete={onDelete}
                    onMoveUp={onMoveUp}
                    onMoveDown={onMoveDown}
                />
            </div>
        </PageBlockToolbarWrapper>
    );
};

export default PageBlockChecklistMenu;
